import { mode, StyleFunctionProps } from "@chakra-ui/theme-tools";

export const chakraStyles = {
  global: (props: StyleFunctionProps) => ({
    body: {
      color: "default",
      bg: "bg-canvas",
    },
    "*::placeholder": {
      opacity: 1,
      color: "muted",
    },
    "*, *::before, &::after": {
      borderColor: mode("gray.200", "gray.700")(props),
    },
    "html,body": {
      height: "100%",
    },
    "#__next, #root": {
      display: "flex",
      flexDirection: "column",
      minH: "100%",
    },
  }),
};

export const styles = {
  global: (props: StyleFunctionProps) => ({
    ...chakraStyles.global(props),
    a: {
      px: 1,
    },
    body: {
      ...chakraStyles.global(props).body,
      color: "fg-main",
      fontFamily: "Moderat",
    },
  }),
};
